import React, { useEffect, useState } from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Tab, Tabs, TextField, Button } from '@mui/material';
import { getActiveProjects } from '../../api/projectApi';
import { getUserProject } from '../../api/userApi';
import { Project } from '../../types/projectTypes';
import ProductionVerification from './ProductionVerification';
import ConsolidatedPerformanceReport from './ConsolidatedPerformanceReport';
import { profiles, ADMIN_SISTEMA } from "../../contexts/constants/profiles";

const ConsolidatedPerformance: React.FC = () => {

    const [tabIndex, setTabIndex] = useState(0);
    const [projects, setProjects] = useState<Project[]>([]);
    const [selectedProject, setSelectedProject] = useState<number>();

    // Estado para las fechas de filtro
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [filterTrigger, setFilterTrigger] = useState(false);


    useEffect(() => {
        fetchProjects();
    }, []);

    const fetchProjects = async () => {
        try {
            // 1. Obtener datos del usuario
            const userStr = localStorage.getItem('user');
            let rut = '';
            let role = '';

            if (userStr) {
                const user = JSON.parse(userStr);
                rut = user.identificationNum;
                role = user.rols?.description;
            }

            let projectsData: Project[] = [];
            if (role === profiles[0].name || role === profiles[2].name || role === profiles[3].name || role === ADMIN_SISTEMA) {
                projectsData = await getActiveProjects();
            } else {
                // Si es otro rol -> Traer solo los asignados
                const userProjects = await getUserProject(rut);
                projectsData = Array.isArray(userProjects) ? userProjects : [];
            }

            // 3. Filtrar borrados lógicos (status === false)
            const validProjects = projectsData.filter(p => p.status === undefined || p.status === true);

            setProjects(validProjects);

        } catch (error) {
            console.error("Error al cargar proyectos:", error);
            setProjects([]);
        }
    };

    const handleTabChange = (event: React.SyntheticEvent, newIndex: number) => {
        setTabIndex(newIndex);
    };

    const handleProjectChange = (event: SelectChangeEvent<number>) => {
        setSelectedProject(Number(event.target.value));
    };

    const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEndDate(event.target.value);
    };


    return (
        <Box sx={{ p: 3 }}>
            <FormControl fullWidth sx={{ marginBottom: 3 }}>
                <InputLabel>Seleccionar Proyecto</InputLabel>
                <Select
                    label="Seleccionar Proyecto"
                    value={selectedProject || ""}
                    onChange={handleProjectChange}
                >
                    {projects.map((project) => (
                        <MenuItem key={project.id} value={project.id}>
                            {project.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Filtro de Fechas */}
            <Grid container spacing={2} sx={{ marginBottom: 3 }}>
                <Grid item xs={6}>
                    <TextField
                        label="Fecha de Inicio"
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Fecha de Término"
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setFilterTrigger(prev => !prev)} // Nuevo estado para disparar la actualización
                >
                    Filtrar
                </Button>
            </Box>

            <Tabs value={tabIndex} onChange={handleTabChange} sx={{ marginTop: 2 }}>
                <Tab label="Consolidado de Rendimientos" />
                <Tab label="Verificación de Producción" />
            </Tabs>

            {tabIndex === 0 && <ConsolidatedPerformanceReport selectedProject={selectedProject} startDate={startDate} endDate={endDate} filterTrigger={filterTrigger} />}
            {tabIndex === 1 && <ProductionVerification selectedProject={selectedProject} />}
        </Box>
    );
}

export default ConsolidatedPerformance;